module.exports = __webpack_public_path__ + "img/logo-sign.d2cf8d89.jpg";